import axios from "axios";

//URL del backend por entorno (.env): REACT_APP_API_URL. Si no está definida se usa la de dev, como hasta ahora.
export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://ot7pa7mgj5.execute-api.eu-central-1.amazonaws.com/dev",
});

export const instanceJA = axios.create({
  baseURL: process.env.REACT_APP_JUNTA_ANDALUCIA_API,
});

export const instanceEST = axios.create({
  baseURL: process.env.REACT_APP_ESTACIONES_API,
});


instance.interceptors.response.use(
    (response) => successHandler(response),
    (error) => errorHandler(error)
);

instanceJA.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.data) {
      error.response.data.message = 'error estaciones';
    } else if (error.response) {
      error.response.data = { message: 'error estaciones' };
    } else {
      error.message = 'error estaciones';
    }
    return Promise.reject(error);
  }
);

  const successHandler = (response) => {
    return response;
  };

  //Sesión caducada o token no válido: 401, o el 403 sin cuerpo JSON ("Forbidden") que daba el backend antiguo.
  //El resto de 403 ("el recurso no es tuyo") y los errores del servidor no cierran la sesión.
  const esErrorDeSesion = (response) => {
    if (!response) {
      return false;
    }
    return response.status === 401 || (response.status === 403 && response.data === 'Forbidden');
  };

  const errorHandler = async (error) => {
    //Sin respuesta (red caída, timeout, CORS): error.response no existe
    if(esErrorDeSesion(error.response)){
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('userData');
        window.location = '/';
    }
    return Promise.reject(error);
  };
